import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Textarea,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import {submitBranchCommission, updateBranchCommission} from "../../services/branch_commission/branch_commission";

export function BranchCommissionForm({branchCommission, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {

  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [fieldTitle, setFieldTitle] = useState("");
  const [branchTitle, setBranchTitle] = useState("");
  const [consultationCommission, setConsultationCommission] = useState(null);
  const [consultationVatPercentage, setConsultationVatPercentage] = useState(null);
  const [serviceCommission, setServiceCommission] = useState(null);
  const [serviceVatPercentage, setServiceVatPercentage] = useState(null);
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState(false)

  useEffect(() => {
    setId((branchCommission && branchCommission.id) || 0);
    setBranchId((branchCommission && branchCommission.branch_id) || null);
    setFieldTitle((branchCommission && branchCommission.field_title) || "");
    setBranchTitle((branchCommission && branchCommission.branch_title) || "");
    setConsultationCommission((branchCommission && branchCommission.consultation_commission) || null);
    setConsultationVatPercentage((branchCommission && branchCommission.consultation_vat_percentage) || null);
    setServiceCommission((branchCommission && branchCommission.service_commission) || null);
    setServiceVatPercentage((branchCommission && branchCommission.service_vat_percentage) || null);
    setDescription((branchCommission && branchCommission.description) || "");
    setStatus(branchCommission && branchCommission.status && branchCommission.status === 'enable' ? true : false);
  }, [branchCommission, open]);

  const save = async () => {
    const data = {
      branch_id: branchId,
      consultation_commission: parseInt(consultationCommission),
      consultation_vat_percentage: parseInt(consultationVatPercentage),
      service_commission: parseInt(serviceCommission),
      service_vat_percentage: parseInt(serviceVatPercentage),
      description: description,
      status: status ? "enable" : "disable"
    };
    let result;

    if (id === 0) {
      result = await submitBranchCommission(data);
    } else {
      data.id = id
      result = await updateBranchCommission(data);
    }

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <>
      <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>{"تعیین کمیسیون خدمات " + fieldTitle + " - " + branchTitle}</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="mb-4">
            <Input variant="standard"
                   value={consultationCommission}
                   label={Dict('consultation_commission')}
                   placeholder={Dict('consultation_commission')}
                   onChange={(e) => {
                     setConsultationCommission(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={consultationVatPercentage}
                   label={Dict('consultation_vat_percentage')}
                   placeholder={Dict('consultation_vat_percentage')}
                   onChange={(e) => {
                     setConsultationVatPercentage(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={serviceCommission}
                   label={Dict('service_commission')}
                   placeholder={Dict('service_commission')}
                   onChange={(e) => {
                     setServiceCommission(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Input variant="standard"
                   value={serviceVatPercentage}
                   label={Dict('service_vat_percentage')}
                   placeholder={Dict('service_vat_percentage')}
                   onChange={(e) => {
                     setServiceVatPercentage(e.target.value)
                   }}
            />
          </div>

          <div className="mb-4">
            <Textarea variant="standard"
                      value={description}
                      label="توضیحات"
                      placeholder="توضیحات"
                      onChange={(e) => {
                        setDescription(e.target.value)
                      }}
            />
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  فعال/غیرفعال
                </Typography>
              }
              checked={status}
              onChange={(e) => {
                setStatus(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ذخیره</span>
          </Button>
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}